<div class="home-sidebar-left-menu">
    <div class="related">
        <h2>
            Categories
        </h2>
        <p><a [class.active]="selectedSection == 'alerts'" routerLink="/alerts">Med Alert Notifications ({{medAlertsCount}}) </a></p>
        <p><a [class.active]="selectedSection == 'formulary' " [hidden]="true" routerLink="/home/compliance">Formulary Compliance ({{complianceCount}}) </a></p>
        <p *ngIf = "!isBOOnly"><a [class.active]="selectedSection == 'clarifications'" routerLink="/home/clarifications">Clarifications ({{clarificationCount}}) </a></p>
        <p *ngIf = "!isBOOnly"><a [class.active]="selectedSection == 'owed'" routerLink="/home/medications">Owed Medications ({{owedCount}}) </a></p>
        <p *ngIf="showPriorAuth"><a [class.active]="selectedSection == 'priorAuth'" routerLink="/home/priorAuth-coveredAlt">Prior Auth/Covered Alt ({{priorAuthCount}}) </a></p>
    </div>
</div>